// import { OktaAuth } from '@okta/okta-auth-js';
import { Notes } from './../../types';
/* eslint-disable no-async-promise-executor */
import { deleteCall, fetchCall, postCall } from '../../services/api';
import { store } from '../../redux/store';
import { OktaAuth } from '@okta/okta-auth-js';
import { tokenHasExpired } from '../../helpers/auth';

/**
 * Handles total overview data fetching and aggregation
 * @param marketFilters
 * @param dateFilters
 * @returns {Promise<SummaryData>} promise value with summary data
 */

export async function fetchNotes(params: any, oktaAuth: OktaAuth): Promise<Notes> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetchCall(`${api}/notes`, params);
      oktaAuth?.tokenManager.get('idToken').then((idToken) => {
        if (Date.now() + 3600 * 1000 - idToken.expiresAt * 1000 > 60000) {
          tokenHasExpired(200, oktaAuth);
        }
      });
      resolve(response);
    } catch (error) {
      console.error(error);
      reject('Error fetching sales overview data. Please try again.');
    }
  });
}

/**
 * Handles saving new note along with associated metadata
 * @param requestBody {Object}
 * @returns {Promise<any>} promise value with response
 */
export async function postNote(requestBody: any): Promise<any> {
  const api = store.getState().config.react_app_api_base_url;
  return new Promise((resolve, reject) => {
    try {
      resolve(postCall(`${api}/notes/save`, requestBody));
    } catch (error) {
      console.error(error);
      reject('Error posting new note. Please try again.');
    }
  });
}

export async function deleteNote(noteId: any): Promise<Notes> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await deleteCall(`${api}/notes/delete/${noteId}`));
    } catch (error) {
      console.error(error);
      reject('Error deleting note. Please try again.');
    }
  });
}

export async function fetchUnreadNotesCount(): Promise<{ newMsgsCount: number }> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/notes/unread/count`));
    } catch (error) {
      console.error(error);
      reject('Error fetching unread count of notes. Please try again.');
    }
  });
}

export const noteFilters = ['All', 'Sales', 'Media', 'Digital Shelf', 'General'];
export const dateFilters = ['January 2021', 'February 2021'];
export const tags = ['Sales', 'Share', 'Media', 'Digital Shelf', 'General'];
